import { JSXElementConstructor } from "react";
import { DynamicComponentList } from "lib/dynamicComponentList";

interface DynamicComponent {
  Component: JSXElementConstructor<{ content: any }>;
  name: string;
  wd: boolean;
}

function getDynamicComponents<PageComponents>({
  pageComponents,
  dynamicComponentList,
}: {
  pageComponents: PageComponents;
  dynamicComponentList: DynamicComponentList;
}): DynamicComponent[] {
  // eslint-disable-next-line array-callback-return
  const components: DynamicComponent[] = (pageComponents as any).map((component: any) => {
    const dynamicComponent = Object.entries(dynamicComponentList).find((dynamicComponent) => {
      return component.__typename.toLowerCase().split("wd")[0].endsWith(dynamicComponent[0].toLowerCase());
    });

    if (dynamicComponent) {
      return {
        Component: dynamicComponent[1],
        name: dynamicComponent[0].toLowerCase(),
        wd: component.__typename.toLowerCase().endsWith("wd"),
      };
    }
  });

  return components.filter((component) => !!component);
}

export { getDynamicComponents };
export type { DynamicComponent };
